import { render } from "./Spinner.vue?vue&type=template&id=409c893e&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=409c893e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409c893e"]])

export default __exports__